export const OPEN_IMAGE_GALLERY_MODAL = 'OPEN_IMAGE_GALLERY_MODAL';
